import { h, Component } from "preact";
import "./passwordApplet.scss";

interface PasswordAppletProps {
    title?: string;
    description?: string;
    requireConfirmation?: boolean;
    okButton?: string;
    cancelButton?: string;
    allowCancel?: boolean;
}

interface PasswordAppletState {
    password: string;
    password2: string;
}

export class PasswordApplet extends Component<PasswordAppletProps, PasswordAppletState> {
    constructor(props: PasswordAppletProps) {
        super(props);

        this.state = {
            password: "",
            password2: ""
        };
    }

    render(props: PasswordAppletProps, state: PasswordAppletState) {
        return (
            <div className="applet__password">
                {
                    !!props.title && <div>{props.title}</div>
                }
                {
                    !!props.description && <div>{props.description}</div>
                }
                <div>
                    <div>New Password</div>
                    <input type="password" value={state.password} autoComplete="new-password" />
                </div>
                {
                    props.requireConfirmation && (
                        <div>
                            <div>Confirm Password</div>
                            <input type="password" value={state.password2} autoComplete="new-password" />
                        </div>
                    )
                }
                <div>
                    <input class="button__primary" type="button" value={props.okButton || "Ok"} />
                    {
                        (props.allowCancel === undefined || props.allowCancel === true) && (
                            <input className="button__secondary" type="button" value={props.cancelButton || "Cancel"} />
                        )
                    }
                </div>
            </div>
        );
    }
}
